import { ECareerLandingPageTabs } from '@configs'
import { Tabs } from 'antd'
import { useEffect, useState } from 'react'
import { Text } from 'src/common'
import { WhyJoinUs } from 'src/components/career-landing-page-management'
import AboutLLCTab from 'src/components/career-landing-page-management/aboutLLC/AboutLLCTab'
import { ApplicationProcess } from 'src/components/career-landing-page-management/applicationProcess'
import BannerTab from 'src/components/career-landing-page-management/banner/BannerTab'
import { ExploreOurOpportunity } from 'src/components/career-landing-page-management/exploreOurOpportunity/ExploreOurOpportunity'
import CareerPageSeo from 'src/components/career-landing-page-management/seoConfig/CareerPageSeo'
import EvolvePageSeo from 'src/components/career-landing-page-management/seoConfig/CareerPageSeo'
import styled from 'styled-components'

interface ICareerLandingPageManagementProps { }

const CareerLandingPageManagement = ({ }: ICareerLandingPageManagementProps) => {

  const [activeTab, setActiveTab] = useState<string>(
    ECareerLandingPageTabs.BANNER
  )

  const tabItems = [
    {
      label: <Text>{ECareerLandingPageTabs.BANNER}</Text>,
      key: ECareerLandingPageTabs.BANNER,
      children: <BannerTab activeTab={activeTab} />,
    },
    {
      label: <Text>{ECareerLandingPageTabs.ABOUT_LLC}</Text>,
      key: ECareerLandingPageTabs.ABOUT_LLC,
      children: <AboutLLCTab activeTab={activeTab} />,
    },
    {
      label: <Text>{ECareerLandingPageTabs.EXPLORE_OUR}</Text>,
      key: ECareerLandingPageTabs.EXPLORE_OUR,
      children: <ExploreOurOpportunity activeTab={activeTab} />,
    },
    {
      label: <Text>{ECareerLandingPageTabs.WHY_JOIN_US}</Text>,
      key: ECareerLandingPageTabs.WHY_JOIN_US,
      children: <WhyJoinUs activeTab={activeTab} />,
    },
    {
      label: <Text>{ECareerLandingPageTabs.APPLICATION_PROCESS}</Text>,
      key: ECareerLandingPageTabs.APPLICATION_PROCESS,
      children: <ApplicationProcess activeTab={activeTab} />,
    },
    {
      label: <Text>{ECareerLandingPageTabs.SEO_CONFIG}</Text>,
      key: ECareerLandingPageTabs.SEO_CONFIG,
      children: <CareerPageSeo activeTab={activeTab} />,
    },
  ]

  return (
    <CareerPageStyled>
      <Tabs
        destroyInactiveTabPane={true}
        defaultActiveKey={ECareerLandingPageTabs.BANNER}
        type="card"
        size={'small'}
        items={tabItems}
        defaultChecked={true}
        activeKey={activeTab}
        onChange={(e) => {
          setActiveTab(e)
        }}
      />
    </CareerPageStyled>
  )
}

export default CareerLandingPageManagement

const CareerPageStyled = styled('div')(() => {
  return {
    '.ant-tabs-nav': {
      marginBottom: 0,
      paddingLeft: '1.25rem',

      '& .ant-tabs-tab': {
        borderRadius: '0.75rem 0.75rem 0 0 !important',

        '&.ant-tabs-tab-active': {
          span: {
            color: '#009BB7',
            fontWeight: '500',
          },
        },
      },
    },
  }
})
